/**
 * Application configuration
 *
 * This module replaces Next.js's getConfig() with Vite environment variables.
 * All environment variables are prefixed with VITE_ in .env files
 * and accessed via import.meta.env.VITE_*
 *
 * Usage:
 *   import { config } from '@utility/config';
 *   console.log(config.apiPath);
 */

import brands from '@utility/constants/brands';

type AppConfig = {
  // Environment
  env: string;

  // API paths
  apiPath: string;
  prodAPIPath: string;
  appPath: string;

  // Third-party integrations
  stripePublicKey: string;
  googlePlacesAPI: string;
  shopifyApiKey: string;

  // WooCommerce
  wcCallbackURL: string;

  // White label
  whiteLabel: string;
};

export const config: AppConfig = {
  // Environment
  env: import.meta.env.VITE_ENV || 'DEVELOPMENT',

  // API paths
  apiPath: import.meta.env.VITE_API_PATH || '',
  prodAPIPath: import.meta.env.VITE_PROD_API_PATH || '',
  appPath: import.meta.env.VITE_APP_PATH || '',

  // Third-party integrations
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',
  googlePlacesAPI: import.meta.env.VITE_GOOGLE_PLACES_API || '',
  shopifyApiKey: import.meta.env.VITE_SHOPIFY_PUBLIC_API_KEY || '',

  // WooCommerce
  wcCallbackURL: import.meta.env.VITE_WC_CALLBACK_URL || '',

  // White label
  whiteLabel: import.meta.env.VITE_WHITELABEL || 'SKUPREME',
};

// Brand configuration helper - provides easy access to current brand settings
export const brand = brands[config.whiteLabel as keyof typeof brands];
